import { Button } from "react-bootstrap";
import { useState, useEffect, useCallback, useRef } from "react";
import * as APIModels from "../../../models";
import Select, { ActionMeta } from "react-select";
import { DataService } from "../../../services/DataService";
import { RecordsService } from "../../../services/RecordsService";
import { ClientService } from "../../../services/ClientService";
import CaseSelectModal from "./modals/CaseSelectModal";
import useInterval from "../../../helpers/hooks/useInterval";
import React from "react";
import { emptyString } from "react-select/src/utils";

type MyOptionType = { label: string; value: string };

export default function CaseSearchLong({
    submission,
    onSearchComplete,
}: {
    submission: APIModels.Submission;
    onSearchComplete: (
        request: APIModels.CaseSearch,
        result: APIModels.CourtCase
    ) => void;
}) {
    type Delay = number | null;
    const [delay, setDelay] = useState(1000);
    const [isRunning, setIsRunning] = useState(false);
    const [statusId, setStatusId] = useState("");
    const [request, setRequest] = useState(new APIModels.CaseSearch());

    useInterval(
        () => {
            RecordsService.poll({ id: statusId }).then(
                (resp) => {
                    setErrorMessage(resp.errorMessage ?? "");
                    //console.log(resp);
                    if (resp.data?.length === 1) {
                        if (resp.data![0].countyID != APIModels.EmptyGuid) {
                            resp.data[0].county = countyOptions.find(
                                (c) => c.value === resp.data![0].countyID
                            )?.label;
                        }
                        if (resp.data![0].divisionID != APIModels.EmptyGuid) {
                            resp.data[0].division = divisionOptions.find(
                                (c) => c.value === resp.data![0].divisionID
                            )?.label;
                        }
                        onSearchComplete(request, resp.data[0]);
                        setIsRunning(false);
                        setSearching(false);
                    } else if (resp.data && resp.data?.length > 1) {
                        //We will need to show the modal to select which case
                        setSearchResults(resp.data ?? []);
                        setIsRunning(false);
                        setSearching(false);
                    } else if (resp.errorMessage != null && !resp.successful) {
                        onSearchComplete(request, [] as APIModels.CourtCase);
                        setIsRunning(false);
                        setSearching(false);
                    }
                },
                (error) => {
                    setSearching(false);
                    setIsRunning(false);
                    console.log(error);
                    setErrorMessage("An error has occurred");
                }
            );
        },
        isRunning ? delay : null
    );

    let options: MyOptionType[] = [];

    const [currentSubmission, setCurrentSubmission] = useState(submission);

    const [showMore, setShowMore] = useState(false);

    const [portalIdentifier, setPortalIdentifier] = useState(
        submission.portalIdentifier
    );
    const [countyId, setCountyId] = useState(submission.caseData!.countyID);
    const [countyOptions, setCountyOptions] = useState(options);
    const [counties, setCounties] = useState([] as APIModels.County[]);

    const [divisionId, setDivisionId] = useState(
        submission.caseData!.divisionID
    );
    const [divisionOptions, setDivisionOptions] = useState(options);

    const [courtType, setCourtType] = useState("");
    const [courtTypeOptions, setCourtTypeOptions] = useState(options);

    const [ucn, setUCN] = useState(submission.caseData!.ucn);
    const [caseNumber, setCaseNumber] = useState(
        submission.caseData!.courtCaseNumber
    );

    const [sequenceNumber, setSequenceNumber] = useState(
        submission.caseData!.sequenceNumber
    );
    const [year, setYear] = useState(submission.caseData!.year);
    const [partyId, setPartyId] = useState("");
    const [location, setLocation] = useState("");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [organization, setOrganization] = useState("");

    const [searching, setSearching] = useState(false);

    const [errorMessage, setErrorMessage] = useState("");
    const [searchResults, setSearchResults] = useState(
        [] as APIModels.CourtCase[]
    );

    useEffect(() => {
        setCurrentSubmission(submission);
        setPortalIdentifier(submission.portalIdentifier);
        setCountyId(submission.caseData!.countyID);
        setDivisionId(submission.caseData!.divisionID);
        setCourtType("");
        setUCN(submission.caseData?.ucn);
        setCaseNumber(
            submission.portalIdentifier === "FL"
                ? ""
                : submission.caseData?.courtCaseNumber
        );
        setSequenceNumber(
            submission.portalIdentifier === "FL"
                ? submission.caseData?.sequenceNumber
                : ""
        );
        setYear(
            submission.portalIdentifier === "FL"
                ? submission.caseData?.year
                : undefined
        );
        // console.log(caseNumber);
    }, [submission]);

    useEffect(() => {
        //console.log(portalIdentifier);
        if (
            portalIdentifier != "PAL" &&
            portalIdentifier != "GO" &&
            portalIdentifier != undefined
        ) {
            DataService.getCountiesByPortal({ state: portalIdentifier! }).then(
                (resp) => {
                    options = resp.map((v, i) => {
                        return { value: v.id!, label: v.name! };
                    });
                    setCountyOptions(options);
                    setCounties(resp);

                    // setPortalIdentifier(
                    //     counties.find((c) => c.id == countyId)?.portalIdentifier
                    //  );
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }, [portalIdentifier]);

    useEffect(() => {
        if (counties.length > 0) {
            const matchingCounty = counties.find((c) => c.id == countyId);
            if (matchingCounty) {
                setPortalIdentifier(matchingCounty.portalIdentifier);
            }
        }
    }, [counties]);

    useEffect(() => {
        DataService.getDivisions({ countyId: countyId! }).then(
            (resp) => {
                options = resp.map((v, i) => {
                    return { value: v.id!, label: v.name! };
                });
                setDivisionOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [countyId]);

    useEffect(() => {
        DataService.getCourtTypes({ divisionId: divisionId! }).then(
            (resp) => {
                options = resp.map((v, i) => {
                    return { value: v.code!, label: v.name! };
                });
                setCourtTypeOptions(options);
            },
            (error) => {
                console.log(error);
            }
        );
    }, [divisionId]);

    const onCountyChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setCountyId(value?.value);
        setPortalIdentifier(
            counties.find((c) => c.id == value?.value)?.portalIdentifier
        );
    };

    const onDivisionChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setDivisionId(value?.value);
    };

    const onCourtTypeChange = (
        value: MyOptionType | null,
        actionMeta: ActionMeta<MyOptionType>
    ) => {
        setCourtType(value?.value ?? "");
    };

    const caseSearchClick = useCallback(async () => {
        const newRequest: APIModels.CaseSearch = {
            attorneyID: submission.attorneyID,
            ucn: "",
            caseNumber:
                sequenceNumber && sequenceNumber.length > 0 ? "" : caseNumber,
            countyID: countyId,
            divisionID: divisionId,
            courtIdentifier: courtType,
            sequenceNumber: sequenceNumber,
            year: year,
            locationIdentifier: location,
            partyIdentifier: partyId,
            firstName: firstName,
            lastName: lastName,
            organization: organization,
        };
        submission.caseData!.countyID = "";
        submission.documents?.forEach((d) => {
            d.documentType = "";
            d.documentTypeID = "";
        });
        setRequest(newRequest);

        setSearching(true);
        RecordsService.longCaseSearch({ body: newRequest }).then(
            (resp) => {
                //setSearching(false);
                if (resp.successful === true) {
                    setErrorMessage(resp.errorMessage ?? "");
                    setStatusId(resp.data!);
                    setIsRunning(true);
                } else {
                    setErrorMessage(resp.errorMessage ?? "No case found");
                    setSearching(false);
                }
            },
            (error) => {
                setSearching(false);
                console.log(error);
                setErrorMessage("An error has occurred");
            }
        );
    }, [
        countyId,
        divisionId,
        courtType,
        sequenceNumber,
        year,
        caseNumber,
        firstName,
        lastName,
        organization,
        ucn,
        location,
        partyId,
    ]);

    const onSelectCase = useCallback(
        (selectedCase: APIModels.CourtCase) => {
            const request: APIModels.CaseSearch = {
                attorneyID: submission.attorneyID,
                ucn: "",
                caseNumber: caseNumber,
                countyID: countyId,
                divisionID: divisionId,
                courtIdentifier: courtType,
                sequenceNumber: sequenceNumber,
                year: year,
            };

            setSearchResults([]);
            onSearchComplete(request, selectedCase);
        },
        [countyId, divisionId, courtType, sequenceNumber, year, caseNumber, ucn]
    );

    const filterOption = (option: MyOptionType, inputValue: string): boolean =>
        (
            option.label
                .toString()
                .toLowerCase()
                .match(inputValue.toLowerCase()) || []
        ).length > 0;

    return (
        <>
            {searchResults.length > 0 && (
                <CaseSelectModal
                    cases={searchResults}
                    show={true}
                    onSelect={onSelectCase}
                    onClose={() => setSearchResults([])}
                />
            )}

            <div className="row mb-3">
                <div className="col-sm-12"></div>
                <label htmlFor="selCounty" className="form-label">
                    County/Court
                </label>
                <Select
                    id="selCounty"
                    name="selCounty"
                    value={countyOptions.filter((c) => c.value === countyId)}
                    filterOption={filterOption}
                    options={countyOptions}
                    onChange={onCountyChange}
                />
            </div>
            <div className="row mb-3">
                {portalIdentifier === "FL" ? (
                    <>
                        <div className="col-sm-8">
                            <label htmlFor="selDivision" className="form-label">
                                Division
                            </label>
                            <Select
                                id="selDivision"
                                name="selDivision"
                                value={divisionOptions.filter(
                                    (c) => c.value === divisionId
                                )}
                                filterOption={filterOption}
                                options={divisionOptions}
                                onChange={onDivisionChange}
                            />
                        </div>

                        <div className="col-sm-4">
                            <label htmlFor="selCaseType" className="form-label">
                                Court Types
                            </label>
                            <Select
                                id="selCourtType"
                                name="selCourtType"
                                filterOption={filterOption}
                                options={courtTypeOptions}
                                onChange={onCourtTypeChange}
                            />
                        </div>
                    </>
                ) : portalIdentifier === "GA" ? (
                    <div className="col-sm-12">
                        <label htmlFor="selDivision" className="form-label">
                            Division
                        </label>
                        <Select
                            id="selDivision"
                            name="selDivision"
                            value={divisionOptions.filter(
                                (c) => c.value === divisionId
                            )}
                            filterOption={filterOption}
                            options={divisionOptions}
                            onChange={onDivisionChange}
                        />
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {portalIdentifier === "FL" ? (
                <>
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="txtYear" className="form-label">
                                Year
                            </label>
                            <div className="input-group">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="txtYear"
                                    placeholder="Year"
                                    aria-describedby="inputGroupPrepend"
                                    value={year}
                                    onWheel={(event) => {
                                        event.currentTarget.blur();
                                    }}
                                    onChange={(event) => {
                                        setYear(
                                            parseInt(event.currentTarget.value)
                                        );
                                    }}
                                />
                                <div className="invalid-feedback">
                                    Please provide a valid year.
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="txtSeqNum" className="form-label">
                                Sequence Number
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="txtSeqNum"
                                placeholder="Sequence Number"
                                value={sequenceNumber}
                                onChange={(event) =>
                                    setSequenceNumber(event.currentTarget.value)
                                }
                            />
                            <div className="invalid-feedback">
                                Please provide a valid sequence number.
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-sm-6">
                            <label htmlFor="txtPartyId" className="form-label">
                                Party Identifier
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtPartyId"
                                    placeholder="Party Identifier"
                                    aria-describedby="inputGroupPrepend"
                                    value={partyId}
                                    onChange={(event) =>
                                        setPartyId(event.currentTarget.value)
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <label htmlFor="txtLocation" className="form-label">
                                Location
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtLocation"
                                    placeholder="Location"
                                    aria-describedby="inputGroupPrepend"
                                    value={location}
                                    onChange={(event) =>
                                        setLocation(event.currentTarget.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="row mb-3">
                    <label htmlFor="txtCaseNumber" className="form-label">
                        Case Number
                    </label>
                    <div className="input-group">
                        <input
                            type="text"
                            className="form-control"
                            id="txtCaseNumber"
                            placeholder="Case Number"
                            aria-describedby="inputGroupPrepend"
                            value={caseNumber}
                            onChange={(event) => {
                                setCaseNumber(event.currentTarget.value);
                            }}
                        />
                    </div>
                </div>
            )}

            <div className="row mb-3">
                <div className="col-sm-12">
                    <Button
                        variant="link"
                        onClick={() => setShowMore(!showMore)}
                    >
                        More Options
                    </Button>
                    {showMore === true && (
                        <>
                            <div className="row mb-3">
                                <div className="col-sm-6">
                                    <label
                                        htmlFor="txtFirstName"
                                        className="form-label"
                                    >
                                        First Name
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtFirstName"
                                            placeholder="First Name"
                                            aria-describedby="inputGroupPrepend"
                                            value={firstName}
                                            onChange={(event) => {
                                                setFirstName(
                                                    event.currentTarget.value
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <label
                                        htmlFor="txtLastName"
                                        className="form-label"
                                    >
                                        Last Name
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtLastName"
                                            placeholder="Last name"
                                            aria-describedby="inputGroupPrepend"
                                            value={lastName}
                                            onChange={(event) =>
                                                setLastName(
                                                    event.currentTarget.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-12">
                                    <label
                                        htmlFor="txtOrganization"
                                        className="form-label"
                                    >
                                        Organization
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="txtOrganization"
                                            placeholder="Organization"
                                            aria-describedby="inputGroupPrepend"
                                            value={organization}
                                            onChange={(event) =>
                                                setOrganization(
                                                    event.currentTarget.value
                                                )
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-sm-12">
                    {searching ? (
                        <button
                            className="btn btn-primary"
                            type="button"
                            disabled={true}
                        >
                            <span
                                className="spinner-border spinner-border-sm me-1"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Searching...
                        </button>
                    ) : (
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={caseSearchClick}
                        >
                            Search
                        </button>
                    )}
                    <div>{errorMessage}</div>
                </div>
            </div>
        </>
    );
}
